import { clsx } from 'clsx'
import { RoundButton } from 'component/Button/RoundButton'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { session } from 'feature/widget/SessionStore'
import { try_on } from 'feature/widget/TryOnStore'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { ui } from 'store/home/ui/HomeUiStore'
import css from './StandUserPane.module.scss'

export const StandUserPane = observer(() => {
  const demo = useDemo()
  const { mobile } = ui.window
  const { product, widget } = demo
  const { picture, started } = session
  const { gender, outfits } = widget
  const male = gender === 'male'
  const combo_count = comboCartStore.count
  const show_combo = !!product.combination

  const onProfile = useLatestCallback(() => {
    void try_on.openProfile()
  })

  const onOutfits = useLatestCallback(() => {
    void try_on.open()
  })

  const onCombo = useLatestCallback(() => {
    comboCartStore.open = true
  })

  const onExit = useLatestCallback(async () => {
    session.stop()
  })

  return <Space className={css.pane} opposite oh>
    <Space gap={12} tall pad={[6, 8]} round={16} className={css.controls}>
      <Space className={clsx(css.circle, !picture && css.empty)} center round onClick={onProfile}>
        <Space className={css.picture} center round>
          {picture && <Image src={picture} />}
          {!picture && <Icon size={24} name="person" tertiary />}
        </Space>
      </Space>
      <RoundButton height={48} pad={[0, 12]} text onClick={onOutfits}>
        <Icon size={24} name={male ? 'dress_male' : 'dress_female'} />
        <Typo size={20} one semi>
          {outfits}
        </Typo>
      </RoundButton>
      {show_combo && <RoundButton height={48} pad={[0, 12]} text onClick={onCombo}>
        <Icon size={24} name="local_mall" />
        <Typo size={20} one semi>
          {combo_count}
        </Typo>
      </RoundButton>}
    </Space>
    <Space tall>
      {started && <RoundButton pad={mobile ? [0, 26] : [0, 32]} height="100%" danger onClick={onExit}>
        <Typo size={19}>
          {i18n('EndSession')}
        </Typo>
      </RoundButton>}
    </Space>
  </Space>
})
